import { styled } from '@mui/system';
import { Stack, Box } from '@mui/material';

export const CodeBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

export const CodeHeadline = styled(Stack)({
  padding: '20px 20px 0',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const Code = styled(Box)(({ theme }) => ({
  position: 'relative',
  overflow: 'auto',
  fontSize: 14,
  height: '100%',

  '& pre': {
    margin: 0,
    height: '100%',
  },

  '& code': {
    padding: theme.spacing(2),
    height: '100%',
  },
}));
